import React from "react";

export interface BankAccountsTotalCardProps {
  totalAmount: string;
  accountCount: number;
}

export function BankAccountsTotalCard({
  totalAmount,
  accountCount,
}: BankAccountsTotalCardProps) {
  return (
    <div className="flex w-full flex-col items-start gap-4 rounded-lg bg-default-background px-6 py-5 shadow-sm">
      <span className="font-['Inter'] text-[10px] font-[700] leading-[15px] tracking-wide text-neutral-400 uppercase">
        TOTAL AVAILABLE CASH
      </span>
      <div className="flex w-full items-end justify-between">
        <span className="text-heading-1 font-heading-1 text-default-font">
          {totalAmount}
        </span>
        <span className="text-caption font-caption text-subtext-color">
          across {accountCount} account{accountCount !== 1 ? "s" : ""}
        </span>
      </div>
    </div>
  );
}
